import React, { ReactElement, useState } from 'react'
import BackButton from '../../../components/_WMS/BackButton/BackButton'
import { useStepper } from '../../../hooks'
import { StepProps } from './types'

interface StepperShellProps<T> {
  steps: ((props: StepProps<T>) => ReactElement)[]
  initialSharedState?: T // Opcionalmente, define un estado inicial del tipo T
}

export const StepperShell = <T,>({
  steps,
  initialSharedState
}: StepperShellProps<T>) => {
  const {
    currentStep,
    next,
    prev,
    goToStep,
    isFirstStep,
    isLastStep,
    priorStep
  } = useStepper({ steps: steps.length })

  // Usa el tipo T para el estado compartido
  const [sharedState, setSharedState] = useState<T>(initialSharedState as T)

  const CurrentStepComponent = steps[currentStep]({
    currentStep,
    next,
    prev,
    goToStep,
    isFirstStep,
    isLastStep,
    sharedState,
    setSharedState,
    priorStep
  })

  return (
    <div
      style={{
        position: 'relative',
        height: '100%',
        width: '100%',
        backgroundColor: '#FFF'
      }}
    >
      {!isFirstStep && <BackButton onClick={() => goToStep(priorStep)} />}
      {CurrentStepComponent}
    </div>
  )
}
